const pages = new Set(['home', 'products', 'product-detail', 'contact', 'privacy', 'thanks']);

export function go(page: string) {
  if (!pages.has(page)) throw new Error(`Unknown page: ${page}`);
  window.location.assign(page === 'home' ? '/' : `/${page}.html`);
}

export function productUrl(slug: string) {
  return `/products/${encodeURIComponent(slug)}`;
}
